var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"routes":_vm.routes,"profileRoutes":_vm.profileRoutes,"name":"clients"}}),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Footer',{attrs:{"routes":[
            { name: 'General About Us', label: _vm.$translate.text('nav.footer.about') },
            { name: 'General Conditions', label: _vm.$translate.text('nav.footer.conditions') },
            { name: 'General faq', label: _vm.$translate.text('nav.footer.help') },
            { name: 'General Contact Us', label: _vm.$translate.text('nav.footer.contact') }
        ],"name":"clients","showLoggedIn":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }